/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIChannel
 */
export interface APIChannel {
    /**
     * 
     * @type {string}
     * @memberof APIChannel
     */
    readonly self: string;
    /**
     * 
     * @type {string}
     * @memberof APIChannel
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof APIChannel
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof APIChannel
     */
    readonly creator: string;
    /**
     * 
     * @type {string}
     * @memberof APIChannel
     */
    readonly members: string;
    /**
     * 
     * @type {string}
     * @memberof APIChannel
     */
    readonly messages: string;
    /**
     * 
     * @type {Date}
     * @memberof APIChannel
     */
    readonly lastReadAt: Date;
}

/**
 * Check if a given object implements the APIChannel interface.
 */
export function instanceOfAPIChannel(value: object): value is APIChannel {
    if (!('self' in value) || value['self'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('creator' in value) || value['creator'] === undefined) return false;
    if (!('members' in value) || value['members'] === undefined) return false;
    if (!('messages' in value) || value['messages'] === undefined) return false;
    if (!('lastReadAt' in value) || value['lastReadAt'] === undefined) return false;
    return true;
}

export function APIChannelFromJSON(json: any): APIChannel {
    return APIChannelFromJSONTyped(json, false);
}

export function APIChannelFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIChannel {
    if (json == null) {
        return json;
    }
    return {
        
        'self': json['self'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'creator': json['creator'],
        'members': json['members'],
        'messages': json['messages'],
        'lastReadAt': (new Date(json['last_read_at'])),
    };
}

export function APIChannelToJSON(value?: Omit<APIChannel, 'self'|'creator'|'members'|'messages'|'last_read_at'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'description': value['description'],
    };
}

